import { render, staticRenderFns } from "./form-wrapper.vue?vue&type=template&id=0f142efd&scoped=true&"
import script from "./form-wrapper.vue?vue&type=script&lang=js&"
export * from "./form-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f142efd",
  null
  
)

export default component.exports